import { TipoContenedor } from '@shared/enums/tipoContenedor';

export class Medicion{
  id: string;
  codigoContenedor: string;
  codigoTanque: string;
  nombreContenedor: string;
  codigoAeroplanta: string;
  tipoContenedor: TipoContenedor;
  varillado: number;
  nivel: number;
  nivelNatural: number;
  temperatura: number;
  densidad: number;
  nivelAgua: number;
  fechaHora: Date;
  fechaHoraMedicion: string;
  username: string;
}
